import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import ClinicalMedicationHistoryList from './clinical-medication-history-list';
import DATA_SOURCE_TRANSLATIONS from 'app/constants/data-source-translations';

const isEmrNewMedicationEnabled = window.FEATURE_TOGGLES.emr_new_medication;

class ClinicalMedicationListItem extends Component {
  state = {
    showHistoryList: false
  };

  toggleHistoryList = () => {
    this.setState(({ showHistoryList }) => ({ showHistoryList: !showHistoryList }));
  };

  render() {
    const { medication } = this.props;
    const { showHistoryList } = this.state;
    const toggleHistoryListSwitch = showHistoryList ? '-' : '+';

    return (
      <tbody id={`medication-${medication.clinicalMedicationId}`}>
        <tr>
          <td onClick={this.toggleHistoryList}>
            {medication.histories.length > 0 ? toggleHistoryListSwitch : null} {
              (isEmrNewMedicationEnabled && medication.legacyFormatFlg === 'Y')
                ? `${medication.drugName}` + (medication.drugQuantity ? `, ${medication.drugQuantity}` : '')
                : medication.drugName
            }
          </td>
          {!isEmrNewMedicationEnabled && <td>{medication.drugQuantity}</td>}
          <td>{medication.drugFrequency}</td>
          <td>{medication.activelyTakingFlag === 'Y' ? 'Current' : 'Past'}</td>
          <td>
            {medication.serviceDate
              ? moment(medication.serviceDate).format('MM/DD/YYYY HH:mm:ss')
              : moment(medication.createdAt).format('MM/DD/YYYY HH:mm:ss')}
          </td>
          <td>
            <span>{medication.createdByType}</span>
            {medication.providerName && <span> ({medication.providerName})</span>}
          </td>
          <td>
            {DATA_SOURCE_TRANSLATIONS[medication.dataSource] && medication.event
              ? `${DATA_SOURCE_TRANSLATIONS[medication.dataSource]} ${medication.event}`
              : 'Unknown'}
          </td>
          <td>{PORTAL(medication.dataSource)}</td>
        </tr>
        {showHistoryList && medication.histories.length > 0 && (
          <ClinicalMedicationHistoryList histories={medication.histories} />
        )}
      </tbody>
    );
  }
}

ClinicalMedicationListItem.propTypes = {
  medication: PropTypes.object.isRequired
};

const PORTAL = (source) => {
  switch (source) {
    case 'Admin Portal':
      return 'Admin';
    case 'Provider Mobile':
      return 'Provider Mobile';
    case 'Provider Portal':
      return 'Provider Web';
    case 'CCR Portal':
      return 'Callcenter';
    default:
      return 'Other';
  }
};

export default ClinicalMedicationListItem;
